<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    style="background-color: white;"
  >
    <CSidebarBrand class="d-md-down-none mt-3" to="/" style="background-color: white;">
      <img src="../assets/img/logo.png" :height="30" alt="Dashboard of MyVisionX"/> <label class="custom-20px-700 ml-2">MyVisionX</label>
     
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="$options.nav" class="font-color-171717"/>
    <!-- <CRenderFunction flat :content-to-render="selectedNavigationMenu" /> -->
    <!-- <CSidebarMinimizer
      class="d-md-down-none font-color-171717"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    >Logout</CSidebarMinimizer> -->
    <div class="mt-auto"> <!-- Use mt-auto to push the content to the bottom -->
      <div name="CSidebarNavTitle"><label class="ml-3 font-color-667085">Preferences</label></div>
      <CButton class="mb-2" href="Setting"><img style="max-width:30px" src="../assets/img/icon/setting-2.png" alt="logout" class="mr-2"/>Settings</CButton>
      <br />
      <CButton class="mb-2" v-on:click="SignOut()"><img style="max-width:30px" src="../assets/img/icon/help.png" alt="Interviewrr.ai icon logout" class="mr-2"/>Help Center</CButton>
    </div>
  </CSidebar>
</template>

<script>
import nav from './_navOur'
import navOur from './_navOur'

export default {
  name: 'TheSidebar',
  nav,
  navOur,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  },
  data() {
    return {
      user: null,
      email: '',
      selectedNavigationMenu: [],
    };
  },
  async mounted() {
        this.GetInfoUser();
    },
  methods:
  {
    SignOut: function () {
      return this.$API
        .get(this.$SignOut, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.$router.push("/Login");
          }
        });
    },
        getNavigationMenu() {
      
        this.selectedNavigationMenu = navOur;
     
    }
  }
}
</script>
